import React, { useState } from 'react';
import { Boleta } from './types';

interface DetailBoletaProps {
  boleta?: Boleta;
  onGuardar?: () => void;
  onCancelar?: () => void;
}

export function DetalleBoleta({ boleta, onGuardar, onCancelar }: DetailBoletaProps) {
  const initialData: Boleta = boleta || {
    id: '',
    numero: '',
    lote_id: '',
    usuario_id: '',
    fecha_creacion: '',
    estado: 'pendiente',
    productos_aplicados: [],
    empresa_id: '',
  };
  const [formData, setFormData] = useState(initialData);

  const handleSave = async () => {
    try {
      // Placeholder: guardar boleta
      if (onGuardar) onGuardar();
    } catch (error) {
      console.error('Error guardando boleta:', error);
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">✏️ Completar Boleta</h1>
        <div className="flex gap-2">
          <button
            onClick={onCancelar}
            className="px-4 py-2 surface-2 hover-surface ink rounded"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
          >
            Guardar
          </button>
        </div>
      </div>

      <div className="surface p-4 rounded-lg border hair">
        <p className="ink-2">Formulario de completación de boleta</p>
        <div className="mt-4 space-y-4">
          <div>
            <label className="block text-sm ink-2 mb-2">Número</label>
            <input
              type="text"
              value={formData.numero || ''}
              onChange={(e) => setFormData({ ...formData, numero: e.target.value })}
              className="w-full px-3 py-2 surface-2 border hair rounded ink"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetalleBoleta;
